module.exports = __webpack_public_path__ + "img/medicine-schedule.d00558ec.svg";